export default "__VITE_ASSET__ilU9xeSh__"